import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import BWDate from "../Tools/BWDate";
import SearchIcon from "@mui/icons-material/Search";
import {
  VEHICLE_WASH_TYPE_OPTIONS,
  WASH_TYPE_LABELS,
  formatWashTypeKey,
} from "../../constants/washTypes";

export default function SearchWashDialog({ setFilter }) {
  const [open, setOpen] = React.useState(false);
  const [vehicle, setVehicle] = React.useState();
  const [wash, setWash] = React.useState();
  const [bookingDate, setBookingDate] = React.useState();
  const [bookingId, setBookingId] = React.useState();
  const [washingStatus, setWashingStatus] = React.useState();

  React.useEffect(() => {
    setWash("");
  }, [vehicle]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  function createQueryString(filters) {
    // Filter out keys with null, undefined, or empty values
    let queryParams = Object.entries(filters)
      .filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    // Append the query parameters to the base URL
    if (queryParams.length > 0) {
      queryParams = "?" + queryParams;
    }
    return queryParams;
  }

  const handleSearch = () => {
    let filters = {};

    const formattedWashType =
      vehicle && wash ? formatWashTypeKey(wash, vehicle) : wash;

    if (bookingId) {
      filters = { bookingId };
    } else {
      if (vehicle === undefined || vehicle === null || vehicle === "") {
        alert("Please select vehicle type");
        return;
      }
      filters = {
        vehicleType: vehicle,
        washType: formattedWashType,
        bookingDate,
        washingStatus,
      };
    }

    const query = createQueryString(filters);
    setFilter(query);
    console.log(query);
    setWash("");
    setVehicle("");
    setBookingDate("");
    setBookingId("");
    setWashingStatus("");

    setOpen(false);
  };

  return (
    <React.Fragment>
      <SearchIcon onClick={handleClickOpen} />

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="text-center font-bold">
          Search
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              <div>
                <div>
                  <TextField
                    id="booking-id"
                    label="Booking Id"
                    fullWidth
                    onChange={(e) => setBookingId(e.target.value)}
                  />
                </div>
                <div className="mt-4">
                  <FormControl fullWidth>
                    <InputLabel id="wash-label">Vehicle</InputLabel>
                    <Select
                      labelId="vehicle-select-label"
                      id="vehicle-select"
                      label="vehicleType"
                      // defaultValue={vehicle}
                      onChange={(e) => setVehicle(e.target.value)}
                      name="vehicleType"
                    >
                      <MenuItem value="CAR">CAR</MenuItem>
                      <MenuItem value="BIKE">BIKE</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl fullWidth>
                    <InputLabel id="wash-label">Wash type</InputLabel>
                    <Select
                      labelId="wash-select-label"
                      id="wash-select"
                      label="WashType"
                      name="wash"
                      onChange={(e) => setWash(e.target.value)}
                      value={wash || ""}
                      disabled={!vehicle}
                    >
                      {VEHICLE_WASH_TYPE_OPTIONS[vehicle || "CAR"]?.map(
                        (type) => (
                          <MenuItem key={type} value={type}>
                            {WASH_TYPE_LABELS[type] || type}
                          </MenuItem>
                        )
                      )}
                    </Select>
                  </FormControl>
                </div>
                <div className="mt-4">
                  <FormControl fullWidth>
                    <InputLabel id="wash-label">Wash Status</InputLabel>
                    <Select
                      labelId="wash-select-label"
                      id="wash-select"
                      label="washType"
                      // defaultValue={vehicle}
                      onChange={(e) => setWashingStatus(e.target.value)}
                      name="washType"
                    >
                      <MenuItem value="PENDING">PENDING</MenuItem>
                      <MenuItem value="IN_PROGRESS">IN_PROGRESS</MenuItem>
                      <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                      <MenuItem value="CANCELLED">CANCELLED</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="flex justify-between">
                <div className="mt-4">
                  <BWDate
                    label="Booking Date"
                    setBookingDate={setBookingDate}
                  />
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="flex flex-row justify-end gap-4">
            <Button variant="contained" onClick={handleSearch} autoFocus>
              Search
            </Button>
            <Button variant="contained" onClick={handleClose} autoFocus>
              Close
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
